export const Prices = [
  {
    _id: 0,
    name: "Rs 0 to 250",
    array: [0, 250],
  },
  {
    _id: 1,
    name: "Rs 250 to 500",
    array: [250, 500],
  },
  {
    _id: 2,
    name: "Rs 500 to 1000",
    array: [500, 1000],
  },
  {
    _id: 3,
    name: "Rs 1000 to 1500",
    array: [1000, 1500],
  },
  {
    _id: 4,
    name: "Rs 1500 to 2000",
    array: [1500, 2000],
  },
  {
    _id: 5,
    name: "Rs 2000 or more",
    array: [2000, 10000],
  },
];
